import { DeliverySection, FinalSection, HeaderSection, ItemsSection, OtherInformationSection, PaymentSection, SpecificRequirementsSection, TubesAndPipesSection } from "./documentTemplate";
import { CustomerSpecialRequirement, Enquiry, EnquiryHeader, EnquiryHeaderItem } from "./enquiry.model";

export class QuotationDataAndConfiguration {
    quotationData?: QuotationData;
    quotationConfiguration?: string;
    toBeMerged?: boolean;
}

export class QuotationData {
    enquiry?: EnquiryHeader;
    items?: EnquiryHeaderItem[];
    otherInfo?: QuotationDataOtherInfo;
    customerSpecialRequirements?: CustomerSpecialRequirement[];
    hasDeviationList?: boolean;
}

export class QuotationDataOtherInfo {
    offerValidityDate?: number;
    salespersonNameAndSurname?: string;
    salespersonPhone?: string;
    salespersonMail?: string;
    salesOfficeCountry?: string;
}


export class QuotationConfigurationAndPdf {
    quotationConfiguration?: string;
    quotationPdf?: string;
    isFinal: boolean = false;
    isExternalFile: boolean = false;
}

export class QuotationConfigurationTemplate {
    language?: string;
    headerSection?: HeaderSection;
    specificRequirementsSection?: SpecificRequirementsSection;
    otherInformationSection?: OtherInformationSection;
    itemsSection?: ItemsSection[];
    deliverySection?: DeliverySection;
    paymentSection?: PaymentSection;
    finalSection?: FinalSection;
}
